/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S5_BodyInputs */

const en_fc_tut_s5_body = /** @type {(inputs: Fc_Tut_S5_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use ripple, roll, slip and slide trims to refine every edit. Q and W ripple-trim the clip start or end to the playhead; Alt/Option + arrow keys nudge an edit point (add Shift for ×5); J, K and L trim dynamically while playing. Cmd/Ctrl + K adds an edit at the playhead.`)
};

/**
* | output |
* | --- |
* | "Use ripple, roll, slip and slide trims to refine every edit. Q and W ripple-trim the clip start or end to the playhead; Alt/Option + arrow keys nudge an edit..." |
*
* @param {Fc_Tut_S5_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s5_body = /** @type {((inputs?: Fc_Tut_S5_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S5_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s5_body(inputs)
});
export { fc_tut_s5_body as "fc.tut.s5.body" }